import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { Endpoint } from '@core/app/scripts/services/endpoint';
import { HandleData } from '@core/app/scripts/services/handle-data';
import { Utility } from '@core/app/scripts/services/utility';

/**
 * @ngdoc service
 * @name v6CoreModule.legacyEvents
 * @description
 * # legacyEvents
 * This service is used to add events which are sent to the legacy backend via the M2F process.
 */
export class LegacyEvents {
  root: string;

  constructor(
    private $q: ng.IQService,
    private currentSession: CurrentSession,
    private utility: Utility,
    private handleData: HandleData,
    private endpoint: Endpoint,
  ) {
    this.root = endpoint.getLegacyEndpoint() + '/';
  }

  /**
   * @ngdoc
   * @name v6CoreModule.legacyEvents#add
   * @methodOf v6CoreModule.legacyEvents
   *
   * @description
   * Send information to the legacy system basically sending events to foxpro
   * @param {String} method - the API method
   * @param {String} params - the query string parameters
   * @param {Object} [options] optional request options
   * @return {httpPromise} legacy request promise
   */
  add = (method, params, options) => {
    let url, e;

    options = angular.isDefined(options) ? options : {};
    options.withCredentials = angular.isDefined(options.withCredentials)
      ? options.withCredentials
      : false;

    method = method.toLowerCase();

    const authentication =
      '/token__' +
      this.handleData.getSID() +
      '/tenant_id__' +
      encodeURIComponent(this.currentSession.tenantId) +
      '/username__' +
      encodeURIComponent(this.currentSession.username);

    if (
      method === 'sendinventory' ||
      method === 'sendxtransit' ||
      method === 'sendorder' ||
      method === 'addcoupon' ||
      method === 'redeemcoupon' ||
      method === 'paystorecredit' ||
      method === 'opencashregister'
    ) {
      e = {
        fpquery: method + authentication + '/' + params,
        confirmed: false,
        method: method,
      };
      return (
        this.handleData
          // @ts-ignore
          .addData(
            {
              resource: 'events',
            },
            e,
            undefined,
            undefined,
            options,
          )
          .then((response) => {
            // unwrap returned data
            const { data } = response;

            if (
              angular.isArray(data) ||
              angular.isObject(data) ||
              data === 'success'
            ) {
              return data;
            } else {
              return this.$q.reject(data);
            }
          })
      );
    } else {
      params = params ? params : '';
      url = this.root + method + authentication + '/' + params;
      return (
        this.handleData
          // @ts-ignore
          .get(url, undefined, undefined, options)
          // @ts-ignore
          .then((response) => {
            // unwrap returned data
            const { data } = response;

            if (
              angular.isArray(data) ||
              angular.isObject(data) ||
              data === 'success'
            ) {
              return data;
            } else {
              return this.$q.reject(data);
            }
          })
      );
    }
  };

  /**
   * @ngdoc
   * @name v6CoreModule.legacyEvents#sendAddCoupon
   * @methodOf v6CoreModule.legacyEvents
   * @param {object} coupon
   * transaction.coupon
   * @param {string} customerId customer id which is the UUID
   * of the customer record. This parameter is optional.
   * @description
   * Send information to the foxpro about created coupon
   */
  sendAddCoupon = (coupon, customerId) => {
    let postData = 'coupontype__' + coupon.type;
    postData += '/couponid__' + coupon.id;

    if (customerId) {
      postData += '/uuid__' + customerId;
    }

    // @ts-ignore
    postData += '/value__' + this.utility.round0(coupon.value * 100);

    // @ts-ignore
    return this.add('addCoupon', postData);
  };
}

angular
  .module('v6CoreModule')
  .service(
    'legacyEvents',
    function (
      $q: ng.IQService,
      currentSession: CurrentSession,
      utility: Utility,
      handleData: HandleData,
      endpoint: Endpoint,
    ) {
      return new LegacyEvents(
        $q,
        currentSession,
        utility,
        handleData,
        endpoint,
      );
    },
  );
